module.exports = __webpack_public_path__ + "static/img/cover.c23eb1ce.png";